import { ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { AccordionContext } from './Accordion';

interface IAccordionBody {
  className?: string;
  children?: ReactNode;
}

const AccordionBody = ({ className, children }: IAccordionBody) => {
  const { open } = useContext(AccordionContext);

  return (
    <div
      className={`w-full h-full transition-all ease-linear duration-200 overflow-y-scroll no-scrollbar max-h-96`}
      style={open ? { height: 'auto' } : { height: 0 }}
    >
      <div className={className}>{children}</div>
    </div>
  );
};

export default AccordionBody;
